module.exports = __webpack_public_path__ + "static/img/six1.663a8f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/six1.png
// module id = /BCH
// module chunks = 25